import { PricingStrategyAnchorKeysObject } from '@spoiler-alert/ui-library';

type AnchorValueLabelStrings = {
  flatRate: string;
  percent: string;
};

const anchorValueLabel = (anchorKey: string | undefined, currencyType: string | null | undefined, strings: AnchorValueLabelStrings): string => {
  if (anchorKey !== PricingStrategyAnchorKeysObject.FlatRate) return strings.percent;
  return currencyType ? `${strings.flatRate} (${currencyType})` : strings.flatRate;
};

export default anchorValueLabel;
